<template>
  <div
    v-if="canShowImpactScore"
    class="tw:flex tw:flex-nowrap"
    :class="{
      'tw:min-h-16.5 tw:w-full tw:flex-col tw:gap-2': stacked,
    }"
  >
    <div
      :class="{
        'tw:m-0 tw:flex tw:size-6 tw:items-center tw:p-0': stacked,
        'tw:mr-0.5 tw:pt-0.5': !stacked && dense,
        'tw:ml-1 tw:mr-2 tw:pt-1.5': !stacked && !dense,
      }"
    >
      <BaseIcon
        class="text-ds-denim-9"
        icon="impact-score"
        :style="{ 'font-size': dense ? '20px' : '18px' }"
      />
    </div>

    <div
      :class="{
        'tw:text-sm tw:leading-[1.4]': stacked,
        'tw:text-xxs': !stacked && dense,
        'tw:text-base tw:leading-5': !stacked && !dense,
      }"
    >
      {{ getLocaleText("impact_score_widget.label") }}
      <div
        class="tw:text-left tw:font-bold"
        :class="{
          'tw:text-base': stacked,
          'tw:text-xxs': !stacked && dense,
        }"
      >
        {{
          getLocaleText(
            `impact_score_widget.scores.${props.impactScore?.grade.toLowerCase()}`
          )
        }}
      </div>
    </div>

    <BaseStreemTooltip v-if="!stacked">
      {{ getLocaleText("impact_score_disclaimer") }}
    </BaseStreemTooltip>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseIcon, BaseStreemTooltip } from "shared/components/base";
import type { Nullable } from "shared/types";

export interface ImpactScore {
  grade: string;
  score: number;
}

interface ImpactScoreWidgetProps {
  dense?: boolean;
  impactScore?: Nullable<ImpactScore>;
  stacked?: boolean;
}

const props = defineProps<ImpactScoreWidgetProps>();

const canShowImpactScore = computed(() =>
  Boolean(props.impactScore && props.impactScore?.grade)
);
</script>
